/* eslint-disable no-restricted-imports */

import { belongsTo } from '@ember-data/model';
import Super from './document-request';

export default class DocumentRequestInsuranceInfo extends Super {
  documentIcon = 'shield-filled';
  mixpanelType = 'Insurance information';

  @belongsTo('insurance-info-request-connection', {
    async: false,
    inverse: 'documentRequestInsuranceInfo',
  })
  insuranceInfoRequestConnection;
}
